import React from 'react';
import CurrencyFormat from 'react-currency-format';

const CurrencyInput = ({ price, name, onChange, placeholder="Currency amount", readOnly=false, style={} }) => {

	const onPriceChange = (values) => {
		onChange(values.floatValue);
	}

	return (
		<CurrencyFormat
			className="form-control"
			placeholder={placeholder}
			value={price || ''}
			name={name}
			prefix={'PHP '}
			thousandSeparator={','}
			decimalSeparator={'.'}
			decimalScale={2}
			fixedDecimalScale={true}
			onValueChange={onPriceChange}
			readOnly={readOnly}
			style={style}
		/>
	)
}

export default CurrencyInput;